
import Vue from "vue";
import { Select, Option, Dialog, Button, Message, MessageBox, Popover, Progress } from "element-ui";

// 注意：导入的组件都需要使用 Vue.use() 进行注册
Vue.use(Select);
Vue.use(Option);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Popover);
Vue.use(Progress);
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm